import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "p-mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "p-mb-5"
}
const _hoisted_5 = {
  key: 1,
  class: "p-mb-3"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "password-form p-fluid" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Wählen Sie Ihr Passwort", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", null, "Passwortstärke", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h6", null, "Ihr Passwort muss Folgendes enthalten:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ul", {
  class: "p-pl-2 p-ml-2 p-mt-0",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("li", null, "Mindestens 8 Zeichen")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "new-password" }, "Neues Passwort", -1)
const _hoisted_15 = { class: "p-mt-5 p-mb-3" }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "password-form" }

import { ref, getCurrentInstance } from "vue";
    import { createAuthenticationService } from '../services/authenticationService';
    import { CheckIcon } from '@heroicons/vue/solid';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'EmailVerified',
  emits: ['closed'],
  setup(__props, { expose: __expose, emit: __emit }) {


    const emit = __emit;

    const app = getCurrentInstance();
    const password = ref();
    const display = ref(false);
    const passwordChanged = ref(false);
    const shouldChangePassword = ref(false);
    const user = ref("");

    const service = createAuthenticationService(app);

    const changePassword = async function () {
        await service.changePassword(app, password.value);
        passwordChanged.value = true;
    }

    const show = (customer, changePassword) => {
        display.value = true;
        shouldChangePassword.value = changePassword;
        user.value = customer.firstName + " " + customer.lastName;
    };

    const close = async () => {
        display.value = false;
        if (!shouldChangePassword.value) 
            emit("closed");
    }

    const mediumRegex = ref('^(?=.{8,})');
    const strongRegex = ref('^(?=.{12,})');

    __expose({
        show
    });


return (_ctx: any,_cache: any) => {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: display.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((display).value = $event)),
    modal: true,
    baseZIndex: 106,
    class: _normalizeClass(['medium', {'green': passwordChanged.value}])
  }, {
    default: _withCtx(() => [
      (!passwordChanged.value)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_1, "Hallo " + _toDisplayString(user.value), 1))
        : (_openBlock(), _createElementBlock("strong", _hoisted_2, [
            _createVNode(_unref(CheckIcon), { style: {"width":"25px","color":"#16A34A","position":"relative","top":"6px"} }),
            _createTextVNode(" Ihr Passwort wurde erfolgreich geändert.")
          ])),
      _createElementVNode("div", _hoisted_3, [
        (shouldChangePassword.value && !passwordChanged.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Ihr Account ist nun erfolgreich verifiziert. Bitte wählen Sie ein neues Passwort für Ihren Account."))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, "Ihr Account ist nun vollständig eingerichtet. Sie können die Plattform nun ohne die erneute Eingabe Ihrer Daten nutzen - kostenlos und uneingeschränkt.")),
        (shouldChangePassword.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!passwordChanged.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_Password, {
                          id: "new-password",
                          modelValue: password.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                          autocomplete: "one-time-code",
                          mediumRegex: mediumRegex.value,
                          strongRegex: strongRegex.value,
                          feedback: password.value?.length > 0,
                          toggleMask: "",
                          "data-cy": "reg-password",
                          autofocus: ""
                        }, {
                          header: _withCtx(() => [
                            _hoisted_10,
                            _hoisted_11
                          ]),
                          footer: _withCtx((sp) => [
                            _createTextVNode(_toDisplayString(sp.level) + " ", 1),
                            _createVNode(_component_Divider),
                            _hoisted_12,
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["modelValue", "mediumRegex", "strongRegex", "feedback"]),
                        _hoisted_14
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_Button, {
                          label: "Speichern",
                          onClick: changePassword,
                          "data-cy": "button-change-password"
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Button, {
                  label: "Schließen",
                  onClick: close,
                  "data-cy": "close-reg-form"
                })
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["visible", "class"]))
}
}

})